import React, { useState, useEffect } from "react";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";
import { Field, Form } from "react-jsonschema-form-validation";
import {
	FaCheck,
	FaBatteryHalf,
	FaTemperatureLow,
	FaBed,
	FaToiletPaper,
	FaToiletPaperSlash,
	FaUserInjured,
	FaEyeDropper,
	FaQuestion,
	FaSadTear,
	FaSignLanguage,
	FaThermometer,
	FaTired,
	FaBacterium,
	FaBriefcaseMedical,
	FaHandsWash,
	FaHeadSideCough,
	FaLungs,
	FaHeadSideMask,
	FaCarrot,
	FaRegEye,
	FaHeartbeat,
	FaRegComments,
	FaRegFlushed,
	FaRegFrown,
	FaBrain,
	FaPills,
	FaShoePrints,
	FaSocks,
	FaRegSnowflake,
	FaSyringe,
	FaTeethOpen,
	FaViruses,
	FaPrescriptionBottle,
	FaCapsules,
	FaDeaf,
	FaFingerprint,
	FaHandSparkles,
	FaHeadSideVirus,
	FaMedkit,
	FaDiagnoses,
	FaHandPaper,
	FaWalking,
	FaRegGrimace,
	FaGrimace,
	FaToilet,
} from "react-icons/fa";

const icons = {
	FaCheck,
	FaBatteryHalf,
	FaTemperatureLow,
	FaBed,
	FaToiletPaper,
	FaToiletPaperSlash,
	FaUserInjured,
	FaEyeDropper,
	FaQuestion,
	FaSadTear,
	FaSignLanguage,
	FaThermometer,
	FaTired,
	FaBacterium,
	FaBriefcaseMedical,
	FaHandsWash,
	FaHeadSideCough,
	FaLungs,
	FaHeadSideMask,
	FaCarrot,
	FaRegEye,
	FaHeartbeat,
	FaRegComments,
	FaRegFlushed,
	FaRegFrown,
	FaBrain,
	FaPills,
	FaShoePrints,
	FaSocks,
	FaRegSnowflake,
	FaSyringe,
	FaTeethOpen,
	FaViruses,
	FaPrescriptionBottle,
	FaCapsules,
	FaDeaf,
	FaFingerprint,
	FaHandSparkles,
	FaHeadSideVirus,
	FaMedkit,
	FaDiagnoses,
	FaHandPaper,
	FaWalking,
	FaRegGrimace,
	FaGrimace,
	FaToilet,
};

export const QuestionnaireTrafficLight = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [response, setResponse] = useState({});

	useEffect(() => {
		setResponse(currentResponse?.value || {});
	}, [currentResponse]);

	const onchange = (key, value) => {
		const _response = {};
		_response.id = def.id;
		_response.value = response;
		_response.value[key] = value;

		onRespond(_response);
	};

	const renderOptions = () => {
		return def.options
			? def.options.map((option, i) => {
					const Icon = icons[option.icon] || FaCheck;
					const val = parseInt(response[option.label] || "0", 10);
					const disabledCls = "bg-gray-50 text-gray-400";
					const buttons = option.buttons || {};

					return (
						<div
							key={`${i}_container`}
							className={`w-full px-2 mb-1 ${option.hidden ? "hidden" : ""}`}
						>
							<div className="w-full mb-1">
								<Icon className={"text-xl text-black mr-2 inline font-thin"} />
								<span className="text-md font-bold text-black pr-2">
									{option.label}
								</span>
								{option.info && (
									<span className="text-sm text-gray-600">{option.info}</span>
								)}
							</div>

							<div className={"w-full mb-6"}>
								<div className={`radioSlider`}>
									<Field
										type="radio"
										name={option.label}
										id={`${option.label}_No`}
										className={"hidden radioOption"}
										value={0}
										checked={!val}
										onClick={() => onchange(option.label, 0)}
										disabled={buttons?.none?.disabled}
									/>
									<label
										htmlFor={`${option.label}_No`}
										className={`option ${
											buttons?.none?.disabled
												? disabledCls
												: !val
												? `bg-coolGray-500 text-white font-medium`
												: "bg-gray-100 text-black"
										} ${buttons?.none?.hidden ? "hidden" : ""}`}
									>
										{buttons?.none?.text || "None"}
									</label>

									<Field
										type="radio"
										name={option.label}
										id={`${option.label}_Low`}
										className={"hidden radioOption"}
										value={1}
										checked={val === 1}
										onClick={() => onchange(option.label, 1)}
										disabled={buttons?.mild?.disabled}
									/>
									<label
										htmlFor={`${option.label}_Low`}
										className={`option ${
											buttons?.mild?.disabled
												? disabledCls
												: val === 1
												? `bg-green-600 text-white font-medium`
												: "bg-green-50 text-gray-800"
										} ${buttons?.mild?.hidden ? "hidden" : ""}`}
									>
										{buttons?.mild?.text || "Mild"}
									</label>

									<Field
										type="radio"
										name={option.label}
										id={`${option.label}_Med`}
										className={"hidden radioOption"}
										value={2}
										checked={val === 2}
										onClick={() => onchange(option.label, 2)}
										disabled={buttons?.moderate?.disabled}
									/>
									<label
										htmlFor={`${option.label}_Med`}
										className={`option ${
											buttons?.moderate?.disabled
												? disabledCls
												: val === 2
												? `bg-amber-600 text-white font-medium`
												: "bg-amber-50 text-gray-800"
										} ${buttons?.moderate?.hidden ? "hidden" : ""}`}
									>
										{buttons?.moderate?.text || "Moderate"}
									</label>

									<Field
										type="radio"
										name={option.label}
										id={`${option.label}_High`}
										className={"hidden radioOption"}
										value={3}
										checked={val === 3}
										onClick={() => onchange(option.label, 3)}
										disabled={buttons?.severe?.disabled}
									/>
									<label
										htmlFor={`${option.label}_High`}
										className={`option ${
											buttons?.severe?.disabled
												? disabledCls
												: val === 3
												? `bg-red-600 text-white font-medium`
												: "bg-red-50 text-gray-800"
										} ${buttons?.severe?.hidden ? "hidden" : ""}`}
									>
										{buttons?.severe?.text || "Severe"}
									</label>
								</div>
							</div>
						</div>
					);
			  })
			: null;
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<Form schema={{ type: "object" }}>{renderOptions()}</Form>

			<QuestionnaireFooter def={def} />
		</>
	);
};
